export const QR_CODE_ONLINE_LOGOS_ENDPOINT = '/config/qr-code-logos';

export interface QrCodeOnlineLogoConfig {
  enabled: boolean;
  logoUrls: string[];
}

interface ApiResponse<T> {
  success?: boolean;
  data?: T;
  message?: string;
}

const isSupportedLogoUrl = (value: string) => {
  if (/^\/(?!\/)/.test(value) && !/\s/.test(value)) {
    return true;
  }
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && Boolean(url.host);
  } catch {
    return false;
  }
};

export const resolveQrCodeOnlineLogoUrl = (logoUrl: string) =>
  new URL(logoUrl, window.location.origin).toString();

export const loadQrCodeOnlineLogoConfig = async (): Promise<QrCodeOnlineLogoConfig> => {
  const response = await fetch(QR_CODE_ONLINE_LOGOS_ENDPOINT, {
    method: 'GET',
    credentials: 'include',
    cache: 'no-store',
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch QR code online logos: ${response.status}`);
  }

  const result = await response.json() as ApiResponse<QrCodeOnlineLogoConfig>;
  if (result.success !== true || typeof result.data?.enabled !== 'boolean' || !Array.isArray(result.data.logoUrls)) {
    throw new Error(result.message || 'Invalid QR code online logo response');
  }

  return {
    enabled: result.data.enabled,
    logoUrls: Array.from(new Set(
      result.data.logoUrls
        .filter((logoUrl): logoUrl is string => typeof logoUrl === 'string')
        .map((logoUrl) => logoUrl.trim())
        .filter(isSupportedLogoUrl)
    )),
  };
};
